import { mapActions, mapGetters, mapMutations } from 'vuex'

export const produtosImpulsionadores = {
  props: {},

  data: () => ({}),

  computed: {
    ...mapGetters(['opportunities', 'boostProducts']),
  },

  methods: {
    ...mapMutations(['SET_OPPORTUNITIES', 'SET_OPPORTUNITIES_KEY', 'SET_BOOST_PRODUCTS']),
    ...mapActions(['getProductAnalytics', 'getBoostProducts', 'exportSalesProductsAnalysis']),
  },
}
